<div class="operation-feedback-item">
  <div class="operation-feedback-item-wrapper">
    <div class="operation-feedback-item-status">
      @switch (data().status) {
        @case (operationFeedbackItemDownloadStatus.Progress) {
          <div>
            <fw-progress-spinner
              size="small"
              [mode]="progressValue() ? 'determinate' : 'indeterminate'"
              [value]="progressValue()"
            />
          </div>
        }
        @case (operationFeedbackItemDownloadStatus.Failed) {
          <div><fw-icon color="red" size="medium">warning-circle</fw-icon></div>
        }
        @case (operationFeedbackItemDownloadStatus.Completed) {
          <div><fw-icon color="green" size="medium">done-check-tracked</fw-icon></div>
        }
      }
    </div>
    <div>
      <div class="operation-feedback-item-title" [fwTooltip]="data().title">{{ title() }}</div>

      <div class="operation-feedback-item-subtitle">
        @if (data().currentFile && data().status !== operationFeedbackItemDownloadStatus.Completed) {
          <div>
            <div [fwTooltip]="data().currentFile" [fwTooltipMaxWidthPx]="490">
              {{ currentFileShortName() }}
            </div>
          </div>
        }

        {{ data().downloadedSize ? (data().downloadedSize | storageUnit) : '' }}
        @if (data().downloadedSize && data().totalSize) {
          / {{ data().totalSize | storageUnit }}
        }

        @if (timeLeftData$ | async; as timeLeft) {
          @if (timeLeft && data().status === operationFeedbackItemDownloadStatus.Progress) {
            · {{ timeLeft | formatTime }}
          }
        }
      </div>
    </div>
  </div>
  <div class="operation-feedback-item-wrapper">
    @if (data().status === operationFeedbackItemDownloadStatus.Failed) {
      <fw-icon-button
        color="slate"
        icon="rotate-refresh"
        size="small"
        test-id="retry-download-button"
        (click)="refresh.emit(data())"
      />
    }

    <div>
      <fw-icon-button
        color="slate"
        icon="close"
        size="small"
        test-id="cancel-download-button"
        (click)="onCancelClick()"
      />
      <div #popoverTrigger class="operation-feedback-item-action-popover-trigger"></div>
    </div>

    <fw-popover action="click" position="above-left" [trigger]="popoverTrigger">
      <operation-cancel-popover-body
        cancelTitle="No, do not cancel"
        submitTitle="Yes, cancel download"
        text="If you choose to cancel, the download will be finished, and file will be deleted."
        title="Are you sure you want to cancel?"
        (cancelClick)="closePopover()"
        (submitClick)="cancelClick.emit(data()); closePopover()"
      />
    </fw-popover>
  </div>
</div>
